import axios from "axios";
import { Base_URL } from "../url";

// ✅ GET ALL PROJECT STATUS
export const getAllProjectStatus = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectStatus`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching all project statuses!";
  }
};

// ✅ GET PROJECT STATUS BY ID
export const getProjectStatusById = async (projectStatusId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectStatus/GetStatusById/${projectStatusId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project status by ID!";
  }
};
